var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
export var TeamColorBox = function (_a) {
    var color = _a.color, onClick = _a.onClick, _b = _a.sx, sx = _b === void 0 ? {} : _b;
    return (_jsx(Box, { sx: __assign({ minWidth: 32, minHeight: 32, bgcolor: color, border: "1px solid #ccc", borderRadius: "50%", marginRight: 1 }, sx), onClick: onClick }));
};
